import React from "react";
  import axios from 'axios';
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { useNavigate } from "react-router-dom";

  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";
  import  NuEstado from "components/nubox/NuEstado";
  import EstadoCalificado  from "components/EstadoCalificado";
  import ListFilePeq  from "components/ListFilePeq";

  import cDown from 'helpers/cDown'
  import { withRouterJim } from "router/withRouterJim"; 

  //---cutil
  import cUtilFecha from "helpers/cUtilFecha"
  
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import NuLoading from 'components/nubox/NuLoading';
  import NuInputEdit from 'components/nubox/NuInputEdit';
  

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";





  /*const data = [
    { id_paciente: 1,  nombre: 'ALEX LIZARRAGA', }, 
  ];*/

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ExamendRevListEst extends React.Component {
    state = {

      modalActualizar: false,
      modalInsertar: false,
      isloaging:false,/* cargando ... */
      
      data: [],/* lista de datos */
      row_actual:{},    //auxiliar que permite guardar la fila editada

      examen:{},
      options_demo: [
        { nombre: '1.txt',  filename: 'ALEX LIZARRAGA'}, 
        { nombre: '2.bmp',  filename: 'A LIZARRAGA'}, 
        { nombre: '3.jpg',  filename: 'E LIZARRAGA'}, 
      ],
    };
     //--------------------------------------
    constructor(props) {
      super(props);

      this.modalRef = React.createRef();//create ref
      this.refNuConfirm = React.createRef();
    }
    //------------------
    
    //------------------------------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});

      this.cargar_data();
      
      //this.cargar_cbo();
    }

    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    //-------------- cambiamos valor en la tabla
    handleCellChange=(index, columnId, value, item)=>{
      const newData = [...this.state.data];
      newData[index][columnId] = value;
      
      //console.log(newData);
      //setData({  data: newData    });
      this.setState({ data: newData });
      this.setState({ row_actual: item });  //guardamos en temporal
    }
    handleOKInput=(event)=>{
      //-------lo guardamos en la base de datos
      console.log(event)
      //----lo guardamos en la base de datos
      let id_exaest = this.state.row_actual.id_exaest
      let id_est = this.state.row_actual.id_est
      let nota = event.target.value

      this.save_nota(id_exaest, nota, id_est)
    }
    //---------------------------------
    save_nota = (id_exaest, nota, id_est) => {
      let user = this.props.store.user
      //const materia = this.props.store.materia;
      let id_exa = this.props.params.id
      let param = { 
        id_exaest: id_exaest,
        nota:nota,
        id_exa: id_exa,
        id_est: id_est,
      }
      console.log(param)

      this.setState({isLoading: true});
      axios2.post("examen_rev_list_est_save_nota", param)
      .then(res => {
          this.setState({isLoading: false});

          if(res.data.exito==1){ 
              //this.setState({data: res.data});
              NotificationManager.success("Exito");
          }else{
              NotificationManager.error("Error: 129");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
    //------------------------------------------
    //====================================================== 
    //----cargamos los datos desde la base de datos
    cargar_data = () => {
      //let user = this.props.store.user
      //const materia = this.props.store.materia;
      let id_exa = this.props.params.id

      let param = { 
        id_exa: id_exa,
        
      }
      this.setState({isLoading: true});
      axios2.post("examen_rev_list_est_get_list", param)
      .then(res => {
          this.setState({isLoading: false});
          console.log(res.data)

          if(res.data.collection.length>0){ 
              this.setState({ data: res.data.collection });
              this.setState({ examen: res.data.examen });
          }else{
              NotificationManager.error("No existen datos");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
    imprimir =(id_certi)=>{
      let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL,'',windowFeatures);
    }

    //-----------------------------------------------------------------
  nuevo = () => {
    this.modalRef.current.nuevo();
  }
  //-----------------------------------------------------------------
  
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar.');
    
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        
        let idd = item.id_exa;
        this.save(idd,'x');
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data();
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //-------------------------------------
  //--------------------------------------
  
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  //-------------
  /*onLinkClick = (e,item) => {
    e.preventDefault();
    this.props.navigate('/docente/e/'+ item.id_doc);
  };*/
  descargar_csv =()=>{
    //to={process.env.REACT_APP_API_URL  + `/estudiantes_csv/45/1`
    let user = this.props.store.user
    let id_exa = this.props.params.id
    let id_mate = this.props.store.materia.id_mate

    const urlPath = process.env.REACT_APP_API_URL  + `examen_rev_list_est_csv/${id_mate}/${id_exa}`
    //this.downloadFileCsv(urlPath, "milista.csv")
    cDown.downloadFileCsv(urlPath, "milista.csv")
  }
  //-------------------------------------------
  //-------------
  //=================== SAVE
  save =(idd, ope) =>{
      
    //let param = { idd:idd, ope:ope };
    let param = this.state.form
    param.idd = idd
    param.ope = ope
    console.log(param);

    axios2.post("examend_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);
            this.cargar_data();            
        }else{
            toast.error(res.data.mensaje);
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-------------------------------------
    
    //-------------------------------------
    render() {
      let user = this.props.store.user
      let materia = this.props.store.materia
      return (
        <div>
          <ToastContainer />
          <NotificationContainer/>
          <div className="content">
            {
              //JSON.stringify(this.state.data)
            }
            {/*<!--- ------------------------------->*/}
            <div className="header">							
              <h4>EXAMEN</h4>
                  
                  <Button className="btn btn-info btn-sm"
                      onClick={ this. descargar_csv }
                  >Exportar</Button>

              <h3>{ materia.sigla } - <b>&nbsp;GRUPO:&nbsp;</b>{ materia.grupo}</h3>
              <h4>Examen: &nbsp;{ this.state.examen.titulo }</h4>
            </div>

            
            <NuLoading text="Cargando...." show= { this.state.isloaging }/>

            <div className="table-responsive">
              <table class="table table-striped table-bordered" width="100%" align="center">
                <thead>
                  <tr>
                    
                    <th>Nro.</th>
                    <th>CI</th>
                    <th>APELLIDOS Y NOMBRES</th>
                    
                    <th>Nota</th>
                    <th>Acción</th>
                  
                  </tr>
                </thead>

                <tbody>          
                  {this.state.data.map((item,index) => (
                    <tr key={index}>
                      <td>{ item.id_est}</td>
                      <td>{ item.nro_doc }</td>
                      <td>{ item.nomape_tmp}</td>
                      
                      <td style={{ width:90 }}>
                        <NuInputEdit 
                            type="text"                           
                            className="form-control" 
                            wrapperStyle={{ with:80 }}
                            name="detalle" 
                            value={item.nota}
                            onChange={(e) => this.handleCellChange(index,"nota", e.target.value, item)} 
                            onOkInput={this.handleOKInput }
                            initEdit={true}
                            valtipo='string2'
                            
                        />
                      </td>
                      
                      <td>
                      {/*<Button type="button" 
                              class="btn btn-default btn-sm" 
                              onclick="showmodal( 0 , 'ALDANA ANGULO, LUZ MAYDA ,  ', 4547 );">
                        <i class="fa fa-edit"></i>
                      </Button>
                      */}
                      </td>
                    </tr>
                  ))}
                </tbody>
                 
              </table>
            </div>

          

            
            {/*<!--- ----------------- form busqueda ------------------>*/}

            {/*<!-- -------------------------------------------------->*/}

          </div>
         
          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(ExamendRevListEst);

